export default "__VITE_ASSET__DCb485Am__"